// Mock data para Evolvance

export const heroData = {
  announcement: "Automatizaciones para inmobiliarias y call centers",
  title: "Asistentes IA que atienden tus llamadas y convierten leads",
  subtitle:
    "Automatizamos cada llamada con asistentes de voz, chat IA e integraciones que responden al instante, agendan visitas y actualizan tu CRM sin ampliar equipo.",
  bullets: [
    "Reduce tiempos de atención en cada llamada",
    "Experiencia 24/7 que agenda visitas y seguimientos",
    "Integración directa con CRM, centralita y reporting"
  ],
  backgroundImage: "https://images.pexels.com/photos/20877155/pexels-photo-20877155.jpeg",
  cta: {
    primary: "Prueba nuestro asistente",
    secondary: "Habla con un consultor"
  }
};

export const featuredProducts = [
  {
    id: 1,
    title: "Asistente IA por Voz",
    description: "Transforma la atención a tus clientes con asistentes virtuales por voz que entienden, responden y resuelven 24/7 con tecnología de última generación.",
    features: [
      "Respuestas en tiempo real",
      "Disponibilidad 24/7",
      "Integración con tus sistemas",
      "Análisis de conversaciones"
    ],
    image: "https://images.pexels.com/photos/977296/pexels-photo-977296.jpeg",
    accent: "purple",
    demoType: "voice"
  },
  {
    id: 2,
    title: "Asistente IA por WhatsApp",
    description: "Automatiza tu atención en WhatsApp Business con IA conversacional que capta leads, responde consultas y cierra ventas mientras duermes.",
    features: [
      "Captación automática de leads",
      "Respuestas personalizadas",
      "Seguimiento de conversaciones",
      "Integración con CRM"
    ],
    image: "https://images.pexels.com/photos/46924/pexels-photo-46924.jpeg",
    accent: "green",
    demoType: "whatsapp"
  }
];

export const problemSolutionData = {
  title: "El reto de atender cientos de llamadas sin automatización",
  description:
    "Inmobiliarias y empresas con centralitas saturadas pierden oportunidades por tiempos muertos, seguimiento manual y falta de trazabilidad.",
  industries: [
    {
      id: 1,
      icon: "Building2",
      title: "Inmobiliarias",
      challenges: [
        "Más de 80 llamadas diarias con preguntas repetidas",
        "Agenda de visitas y llaves gestionada a mano",
        "Leads que se enfrían antes de recibir respuesta"
      ],
      outcome: "Asistentes IA que agendan citas, capturan interés y actualizan el CRM al instante."
    },
    {
      id: 2,
      icon: "Headphones",
      title: "Empresas con alta carga telefónica",
      challenges: [
        "Equipos ocupados en tareas de baja complejidad",
        "Falta de visibilidad en qué llamadas convierten",
        "Seguimientos tardíos que reducen cierres"
      ],
      outcome: "Automatización de reservas, avisos y priorización de leads calientes con reporting 24/7."
    }
  ],
  solutionHighlights: [
    {
      id: 1,
      title: "Asistentes de voz y chat IA",
      description: "Contestan, verifican datos y continúan la conversación en cualquier canal."
    },
    {
      id: 2,
      title: "Workflows inteligentes",
      description: "Orquestan llamadas salientes, recordatorios y actualizaciones sin intervención humana."
    },
    {
      id: 3,
      title: "Integración total",
      description: "Conectamos CRM, centralita y Google Sheets para que cada interacción sea medible."
    }
  ]
};

export const benefits = [
  {
    title: "Reducción de tiempos de respuesta",
    description: "Atiende al instante y prioriza por intención real."
  },
  {
    title: "Más leads cualificados",
    description: "Filtrado automático antes de pasar al equipo comercial."
  },
  {
    title: "Atención 24/7",
    description: "Sin ampliar plantilla ni extender turnos."
  },
  {
    title: "Integración con tus sistemas",
    description: "Todo queda registrado en CRM, PBX o BI."
  },
  {
    title: "Mejora de satisfacción",
    description: "Experiencia consistente que refuerza la marca."
  },
  {
    title: "Paneles e informes en vivo",
    description: "Decisiones basadas en datos actualizados al segundo."
  }
];

export const testimonials = [
  {
    id: 1,
    company: "Grupo Habita",
    industry: "Agencia inmobiliaria",
    quote:
      "Reducimos un 65% el tiempo medio de respuesta y duplicamos las visitas confirmadas. El asistente agenda, actualiza el CRM y nos entrega leads listos para cerrar.",
    author: "María Cebrián",
    role: "Directora Comercial",
    metric: "+48% leads cualificados"
  },
  {
    id: 2,
    company: "CallOn24",
    industry: "Centro de llamadas",
    quote:
      "Automatizamos las peticiones repetitivas y el equipo ahora se enfoca en ventas consultivas. El reporte en Sheets nos muestra en tiempo real qué campañas convierten mejor.",
    author: "Javier Moreno",
    role: "Head of Operations",
    metric: "-40% costes operativos"
  }
];

export const finalCTA = {
  title: "Convierte cada llamada en una oportunidad rentable",
  description:
    "Implementa asistentes IA, automatizaciones y reporting conectado a tus sistemas en menos de 30 días.",
  button: "Reservar demo personalizada"
};

export const services = [
  {
    id: 1,
    icon: "PhoneCall",
    title: "Asistente de voz inteligente",
    description:
      "Atiende llamadas, verifica datos y agenda visitas de manera autónoma manteniendo el tono humano de tu marca.",
    color: "purple"
  },
  {
    id: 2,
    icon: "MessageCircle",
    title: "Chatbot con IA conversacional",
    description:
      "Captura leads y resuelve consultas en web y WhatsApp con respuestas guiadas por intención y reglas comerciales.",
    color: "blue"
  },
  {
    id: 3,
    icon: "Plug",
    title: "Integración con CRM y sistemas",
    description:
      "Sincronizamos asistente y centralita con tu CRM, PMS o ERP para que cada dato quede registrado al instante.",
    color: "orange"
  },
  {
    id: 4,
    icon: "GitBranch",
    title: "Automatización de llamadas y flujos",
    description:
      "Diseñamos workflows que disparan recordatorios, seguimientos y cambios de estado sin intervención manual.",
    color: "pink"
  },
  {
    id: 5,
    icon: "Activity",
    title: "Análisis de sentimiento y scoring",
    description:
      "Detectamos urgencia, intención de compra y calidad del lead para priorizar oportunidades con mayor ROI.",
    color: "grey"
  },
  {
    id: 6,
    icon: "BarChart3",
    title: "Paneles e informes en tiempo real",
    description:
      "Dashboards conectados a Google Sheets y BI que muestran volumen de llamadas, conversiones y SLA en vivo.",
    color: "blue"
  }
];

export const brandValues = [
  {
    title: "Exclusividad",
    description: "Cada cliente es único. Evolvance diseña soluciones adaptadas específicamente a las necesidades reales de cada empresa.",
    icon: "Star"
  },
  {
    title: "Calidad",
    description: "El trabajo no se da por finalizado hasta alcanzar el nivel de calidad acordado, cuidando cada detalle del proceso y del resultado final.",
    icon: "Award"
  },
  {
    title: "Cercanía",
    description: "Acompañamiento constante durante todo el proyecto y en la fase posterior, ofreciendo soporte, asesoramiento y seguimiento continuo.",
    icon: "Heart"
  },
  {
    title: "Innovación",
    description: "Uso permanente de tecnologías avanzadas, automatizaciones e inteligencia artificial, manteniéndose siempre actualizado.",
    icon: "Zap"
  }
];

export const caseStudies = [
  {
    id: 1,
    client: "Constructech , SAAS Startups",
    title: "Corecons: CRM de construcción impulsado con IA",
    description: "Convertimos la complejidad de la obra en eficiencia digital. Desarrollamos Corecons para resolver los cuellos de botella reales del sector mediante Inteligencia Artificial: automatizando el seguimiento de proyectos, la gestión de costes y la toma de decisiones. Presupuestos en minutos. No solo creamos software, construimos la tecnología que permite a las startups del sector escalar sin caos.",
    results: "Innovación en tiempo real | Gestión 360° con IA",
    image: "https://iili.io/KVM5tp9.png"
  },
  {
    id: 2,
    client: "Inmobiliaria",
    title: "Percent Servicios Inmobiliarios",
    description: "Automatizamos la gestión de 400 llamadas diarias mediante un asistente de voz con IA. Logramos filtrar y cualificar cada lead en tiempo real, eliminando el cuello de botella y asegurando que el equipo comercial solo atienda oportunidades reales.",
    results: "+200% respuesta rapida, +180% eficencia en leads",
    image: "https://iili.io/qHrzBnI.jpg"
  },
  {
    id: 3,
    client: "Marketing",
    title: "Identidad de marca corporativa: Carlos Reina Asesores",
    description: "Transformamos su nombre en una marca de alto impacto, dotándola de una identidad única y el motor tecnológico necesario para liderar el mercado inmobiliario actual.",
    results: "Personalizado para su negocio",
    image: "https://iili.io/qHrILXV.png"
  },
  {
    id: 4,
    client: 'Desarrollo web, Software',
    title: 'Web Corporativa: Carlos Reina Asesores',
    description: 'Diseñamos y desarrollamos una plataforma web de alto impacto centrada en la conversión y la experiencia de usuario (UX).  El resultado es una herramienta digital que gestiona el tráfico de forma autónoma, proyectando una imagen de máxima profesionalidad y solidez.',
    results: '70% Carga de gestión manual +35% Conversión de clientes',
    image: 'https://iili.io/qBx95Vn.png'
  },
  {
    id: 5,
    client: 'Estrategia Local 360° | Reformas & Instalaciones',
    title: 'Servicios Andalusí: Identidad y dominio digital',
    description: 'Diseñamos su identidad y web profesional para captar proyectos de reforma en Sevilla. Dominamos el posicionamiento en Google Maps para liderar las búsquedas locales de electricidad y fontanería. Optimizamos sus redes sociales como un catálogo de confianza que transforma seguidores en solicitudes reales..',
    results: 'Top 3 Google Maps , +120% Solicitudes de presupuesto',
    image: 'https://iili.io/qf6525b.png'
  },
  {
    id: 6,
    client: 'Ecommerce ',
    title: 'Desarrollo Web y dashboard gestion: Macout',
    description: 'Dashboard a medida para la edición masiva de su catálogo de ordenadores Apple reacondicionados. Control de stock, precios y estados técnicos en tiempo real con una interfaz intuitiva de alta velocidad.',
    results: 'Gestión en tiempo real, +100% Agilidad en catálogo',
    image: 'https://iili.io/qBxNcJV.png'
  }
];

export const companyInfo = {
  name: "Evolvance",
  tagline: "Soluciones tecnológicas premium a medida",
  description: "Empresa tecnológica especializada en el diseño y desarrollo de soluciones digitales personalizadas para empresas que buscan crecer, optimizar procesos y diferenciarse dentro de su sector.",
  location: {
    address: "C. Astronomía, 1, torre 2 , planta 8 , modulo 2, Norte, 41015 Sevilla",
    googleMapsUrl: "https://maps.app.goo.gl/NDiwYgWddM9RMlZb1",
    coordinates: {
      lat: 37.4023,
      lng: -5.9767
    }
  },
  contact: {
    email: "admin@evolvance.es",
    phone: "+34 601 86 96 68",
    phoneSecondary: "+34 613 97 00 23"
  },
  social: {
    linkedin: "https://www.linkedin.com/company/evolvance-es/",
    instagram: "https://www.instagram.com/evol_vance/",
    twitter: "https://x.com/evolvanceIA"
  }
};

// Mock para demo de voice assistant
export const voiceAssistantDemo = {
  status: "idle", // idle, listening, processing, speaking
  conversations: [
    {
      id: 1,
      type: "user",
      text: "¿Cuáles son sus servicios?",
      timestamp: "10:30"
    },
    {
      id: 2,
      type: "assistant",
      text: "Ofrecemos CRM personalizados, desarrollo web, asistentes de IA, estrategias de captación de leads y mucho más. ¿En qué área te gustaría profundizar?",
      timestamp: "10:30"
    }
  ]
};

// Mock para demo de WhatsApp assistant
export const whatsappAssistantDemo = {
  conversations: [
    {
      id: 1,
      type: "user",
      text: "Hola, necesito información sobre sus asistentes de IA",
      timestamp: "14:23",
      status: "delivered"
    },
    {
      id: 2,
      type: "bot",
      text: "¡Hola! 👋 Soy el asistente virtual de Evolvance. Tenemos dos soluciones principales:\n\n🎤 Asistente por Voz\n💬 Asistente por WhatsApp\n\n¿Cuál te interesa más?",
      timestamp: "14:23",
      status: "read"
    },
    {
      id: 3,
      type: "user",
      text: "El de WhatsApp",
      timestamp: "14:24",
      status: "delivered"
    },
    {
      id: 4,
      type: "bot",
      text: "Perfecto! 🚀 Nuestro asistente de WhatsApp puede:\n\n✅ Responder 24/7\n✅ Captar leads automáticamente\n✅ Integrar con tu CRM\n✅ Enviar catálogos y procesar pedidos\n\n¿Te gustaría agendar una demo personalizada?",
      timestamp: "14:24",
      status: "read"
    }
  ]
};

export const faqData = [
  {
    question: "¿Cuánto tiempo tarda un proyecto?",
    answer: "Cada proyecto es único. Un CRM básico puede estar listo en 3-4 semanas, mientras que una aplicación compleja puede tomar 2-3 meses. Siempre establecemos plazos claros desde el inicio."
  },
  {
    question: "¿Ofrecen soporte después del lanzamiento?",
    answer: "Absolutamente. Todos nuestros proyectos incluyen soporte post-lanzamiento. Además, ofrecemos planes de mantenimiento y actualización continua."
  },
  {
    question: "¿Trabajan con empresas de cualquier tamaño?",
    answer: "Sí, trabajamos desde startups hasta grandes empresas. Cada solución se adapta al tamaño, presupuesto y objetivos específicos del cliente."
  },
  {
    question: "¿Los asistentes de IA funcionan en mi idioma?",
    answer: "Nuestros asistentes soportan múltiples idiomas, incluyendo español, inglés, y muchos más. Se configuran específicamente para tu mercado."
  }
];

export const blogPosts = [];

export const blogMetadata = {
  title: "Evolvance Blog | Transformación Digital 360 & Inteligencia Artificial",
  description: "Aprende cómo dominar tu mercado con IA, Marketing Inmersivo y Software a Medida. Guías expertas de Transformación Digital para Inmobiliarias, Clínicas y empresas en España.",
  keywords: "blog transformacion digital, expertos inteligencia artificial españa, marketing inmersivo real estate, consultoria estrategica pymes, automatizacion procesos ia, tendencias tecnologia 2025, evolvance blog",
  ogTitle: "Transformación Digital & IA: El Blog de Evolvance",
  ogDescription: "Descubre las estrategias tecnológicas que están escalando negocios en 2025. Software, IA y Automatización.",
  ogImage: "https://evolvance.es/og-blog.png",
  twitterCard: "summary_large_image"
};

